let swiper;

document.addEventListener("DOMContentLoaded", function () {
  const swiperContainer = document.querySelector(
    ".multi-column-wrapper__slider-mobile"
  );
  const autoplayDelay = swiperContainer.dataset.autoplayDelay;

  if (window.innerWidth < 749) {
    initSwiper(swiperContainer, autoplayDelay);
  }

  window.addEventListener("resize", function () {
    if (window.innerWidth > 749) {
      swiperContainer.classList.remove("swiper");
      swiperContainer
        .querySelector(".multi-column__grid:not(.hide-mobile)")
        .classList.remove("swiper-wrapper");
      swiperContainer
        .querySelectorAll(".multi-column__grid-item")
        .forEach((slide) => {
          slide.classList.remove("swiper-slide");
        });

      if (swiper) {
        swiper.destroy(true, true);
      }
    } else {
      initSwiper(swiperContainer, autoplayDelay);
    }
  });
});

const initSwiper = (swiperContainer, autoplayDelay) => {
  swiperContainer.classList.add("swiper");
  const swiperWrapper = swiperContainer
    .querySelector(".multi-column__grid:not(.hide-mobile)")
    .classList.add("swiper-wrapper");
  const swiperSlides = swiperContainer.querySelectorAll(
    ".multi-column__grid-item"
  );
  swiperSlides.forEach((slide) => {
    slide.classList.add("swiper-slide");
  });

  swiper = new Swiper(swiperContainer, {
    slidesPerView: 2,
    loop: true,
    speed: 4500,
    allowTouchMove: false,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
  });
};
